// Realistic Delhi NCR startup ecosystem placeholder content

export const navLinks = [
  { label: "Home", href: "#home" },
  { label: "News", href: "#news" },
  { label: "Articles", href: "#articles" },
  { label: "Events", href: "#events" },
  { label: "RFT", href: "#rft" },
];

export const teamDropdown = [
  { label: "Mentors", href: "#mentors" },
  { label: "Investors", href: "#investors" },
];

export const moreDropdown = [
  { label: "Partner With Us", href: "contact" },
  { label: "Advertise", href: "contact" },
  { label: "About Us", href: "about" },
  { label: "Contact", href: "contact" },
];

export const curatedNews = [
  {
    id: 1,
    tag: "FUNDING",
    status: "Draft",
    title:
      "D2C Food Startup Anveshan Raises ₹150 Crore in Series B Funding Led by Vertex Ventures",
    subtitle:
      "The Gurugram-based clean-label food brand known for A2 ghee, cold-pressed oils and raw honey has doubled its valuation to over $90 million, drawing backing from IFC, boAt's Aman Gupta and Swiggy's co-founder.",
    time: "2 Jun",
    published: "2 June 2026",
    author: "Startup Unplugged",
    cover: "/news/1.jpg",
    pullQuote:
      '"The investment would help the company make high-quality clean food products accessible to a much larger consumer base." — Kuldeep Parewa, CEO & Co-founder, Anveshan',
    body: [
      "Gurugram-based D2C food startup Anveshan has raised ₹150 crore in a Series B funding round led by Vertex Ventures Southeast Asia & India, marking a major milestone in the company's growth journey. The round also saw participation from the International Finance Corporation (IFC), Swiggy co-founder Sriharsha Majety and existing investors including Wipro Consumer Care Ventures, Titan Capital, Force Ventures and boAt founders Aman Gupta and Sameer Mehta.",
      "Founded in 2020 by IIT Guwahati alumni Kuldeep Parewa, Akhil Kansal and Aayushi Khandelwal, Anveshan has built a strong presence in India's rapidly growing clean-label food segment. The startup offers products such as A2 ghee, cold-pressed oils, raw honey and Indian superfoods, focusing on transparency, traceability and minimally processed nutrition.",
      "The fresh capital will be used to strengthen Anveshan's manufacturing and sourcing ecosystem, expand into new product categories and scale its brand presence across India. The company also plans to invest in quality infrastructure, procurement systems and partnerships with traditional producers and micro-entrepreneurs.",
      "Anveshan has witnessed rapid growth over the past year. According to the company, it is currently operating at an annual revenue run rate of ₹280-300 crore and expects to close FY26 with revenues of ₹200-220 crore. The startup has also built a network of 16 manufacturing facilities across nine states, helping bring traditionally made food products to consumers nationwide.",
      "Speaking on the funding, CEO and co-founder Kuldeep Parewa said the investment would help the company make high-quality clean food products accessible to a much larger consumer base while strengthening its manufacturing and sourcing capabilities.",
      "The funding comes at a time when demand for clean-label, health-focused food products is rising across India. Anveshan says nearly 50-55% of its revenue now comes from Tier 2 and Tier 3 cities, highlighting growing consumer awareness around food quality and nutrition beyond major metros.",
      "With fresh capital, a rapidly expanding customer base, and growing investor confidence, Anveshan is positioning itself as one of the key startups shaping the future of India's clean and traceable food industry.",
    ],
  },
  {
    id: 2,
    tag: "FUNDING",
    status: "Draft",
    title:
      "Simple Energy Raises ₹250 Crore as EV Startup Accelerates Growth Ahead of IPO Plans",
    subtitle:
      "EV startup Simple Energy has raised ₹250 crore in a Series B funding round to expand manufacturing, strengthen its retail network, and accelerate growth. The Bengaluru-based company is also targeting an IPO in FY28 as demand for electric scooters continues to rise.",
    time: "2 Jun",
    published: "2 June 2026",
    author: "Startup Unplugged",
    cover: "/news/2.jpg",
    pullQuote:
      '"Revenue grew more than four times from approximately ₹40 crore to ₹170 crore, reflecting rising consumer demand for electric mobility solutions across India."',
    body: [
      "Bengaluru-based electric vehicle startup Simple Energy has raised ₹250 crore in a Series B funding round comprising a mix of equity and debt, as the company accelerates its expansion plans and prepares for a potential IPO in FY28.",
      "The funding round was led by the family office of Thyrocare founder Arokiaswamy Velumani, along with participation from Simple Energy founders Suhas Rajkumar and Ankit Gupta. The debt component of ₹123 crore was provided by HDFC Bank, Capitar Ventures, and other financial institutions.",
      "Founded in 2019, Simple Energy has emerged as one of India's promising electric two-wheeler startups. The company is best known for its premium electric scooters, including the Simple One, which has gained attention for its long-range capabilities and performance-focused design.",
      "The fresh capital will primarily be used to scale manufacturing operations, expand production capacity, strengthen the company's retail footprint, and invest in research and development. According to the company, a significant portion of the funds will support capacity expansion as it targets aggressive growth over the next two years.",
      "Simple Energy currently has a production capacity of around 3,000 electric scooters per month and aims to increase monthly sales to 10,000 units by March 2027. The company has also invested heavily in its battery manufacturing infrastructure, with additional capacity expected to come online in the coming months.",
      "The startup has witnessed strong business momentum over the past year. According to company statements, revenue grew more than four times from approximately ₹40 crore to ₹170 crore, reflecting rising consumer demand for electric mobility solutions across India.",
      "Beyond manufacturing, Simple Energy is rapidly expanding its retail network. The company currently operates through more than 70 outlets across 38 cities and plans to enter several new markets as it strengthens its pan-India presence.",
      "Looking ahead, the company is targeting an initial public offering in the second half of FY28. Management has indicated that a future IPO could help fund further expansion, product development, and new manufacturing facilities as competition intensifies in India's fast-growing electric vehicle market.",
      "With fresh funding, growing revenues, and ambitious expansion plans, Simple Energy is positioning itself as a key player in India's electric two-wheeler ecosystem as the country continues its shift toward sustainable mobility solutions.",
    ],
  },
  {
    id: 3,
    tag: "OPS",
    status: "Draft",
    title:
      "Travel Startup EaseMyTrip Reports ₹15.4 Crore Q4 FY26 Loss Despite Revenue Growth",
    subtitle:
      "Travel startup EaseMyTrip reported a ₹15.4 crore net loss in Q4 FY26 despite revenue growth. Rising expenses and expansion costs impacted profitability as the company focuses on long-term growth.",
    time: "2 Jun",
    published: "2 June 2026",
    author: "Startup Unplugged",
    cover: "/news/3.jpg",
    pullQuote:
      '"For the full financial year FY26, EaseMyTrip reported a net loss of ₹47.5 crore compared to a profit in the previous fiscal year."',
    body: [
      "Online travel platform EaseMyTrip reported a net loss of ₹15.4 crore for the fourth quarter of FY26, marking a sharp reversal from the profit it recorded during the same period last year. The company's latest earnings highlight the growing pressure on profitability despite continued growth in revenue.",
      "During the January–March quarter, EaseMyTrip's operating revenue rose by nearly 9% year-on-year to ₹152 crore, driven by steady demand across its travel booking segments. However, higher operating expenses, employee costs and increased investments in business expansion weighed heavily on the company's bottom line.",
      "The Gurugram-based travel startup reported total expenses of over ₹170 crore during the quarter, significantly higher than the previous year. As a result, the company slipped into a loss despite maintaining growth in its core business operations.",
      "For the full financial year FY26, EaseMyTrip reported a net loss of ₹47.5 crore compared to a profit in the previous fiscal year. The results reflect the challenges faced by online travel companies as competition intensifies and customer acquisition costs continue to rise.",
      "Over the past year, EaseMyTrip has actively expanded beyond its core flight booking business through investments, acquisitions, and diversification into adjacent travel segments. The company has also been focusing on international expansion and strengthening its presence across hotels, holidays, and other travel services.",
      "Despite the quarterly setback, management remains optimistic about long-term growth prospects, citing strong travel demand, increasing digital adoption, and opportunities in the broader travel ecosystem. The company expects its diversification strategy to contribute more meaningfully to revenue growth in the coming quarters.",
      "The latest earnings come at a time when India's online travel industry is witnessing rapid evolution, with companies investing aggressively to capture market share. While revenue growth remains healthy, profitability is increasingly becoming a key focus area for investors evaluating travel-tech businesses.",
      "As EaseMyTrip navigates a competitive market environment, the company's ability to balance growth with sustainable profitability will remain closely watched by investors and industry observers alike.",
    ],
  },
  {
    id: 4,
    tag: "DEALS",
    status: "Draft",
    title:
      "WealthTech Startup Scripbox Buys Blue Chip Capital's MF Business in Strategic Expansion Move",
    subtitle:
      "Scripbox is doubling down on growth. The WealthTech startup has acquired Blue Chip Capital's MF business to expand its investor network and strengthen its wealth management capabilities.",
    time: "2 Jun",
    published: "2 June 2026",
    author: "Startup Unplugged",
    cover: "/news/4.jpg",
    pullQuote:
      '"Industry experts believe consolidation within the wealth management sector is likely to continue as firms seek scale, operational efficiencies, and stronger customer relationships."',
    body: [
      "WealthTech startup Scripbox has acquired the mutual fund business of Blue Chip Capital, marking another strategic step in its efforts to expand its wealth management footprint and strengthen its position in India's growing investment ecosystem.",
      "The acquisition is expected to strengthen Scripbox's wealth management offerings and expand its presence in the mutual fund distribution business.",
      "Founded in 2012, Scripbox has built a digital-first wealth management platform that offers mutual funds, stocks, fixed-income products, and portfolio advisory services. Over the years, the company has positioned itself as a technology-driven platform focused on helping investors build long-term wealth through simplified investing solutions.",
      "Blue Chip Capital, a well-established investment advisory and mutual fund distribution firm, has served retail and high-net-worth investors for several years. By integrating Blue Chip Capital's mutual fund business into its platform, Scripbox aims to provide existing clients with access to a broader suite of investment products, digital tools, and personalized wealth management services.",
      "The acquisition comes at a time when India's wealth management industry is witnessing rapid growth, driven by increasing retail participation in financial markets, rising awareness of mutual funds, and growing demand for digital investment platforms. WealthTech companies have been actively pursuing acquisitions and partnerships to strengthen market share and accelerate customer acquisition.",
      "For Scripbox, the deal aligns with its long-term strategy of expanding beyond digital investing and building a comprehensive wealth management ecosystem. The company has been steadily enhancing its offerings across financial planning, portfolio management, and investment advisory services to cater to a wider range of investors.",
      "Industry experts believe consolidation within the wealth management sector is likely to continue as firms seek scale, operational efficiencies, and stronger customer relationships. Acquisitions such as this allow digital platforms to rapidly grow their investor base while offering a seamless transition for existing customers.",
      "The acquisition marks another step in Scripbox's efforts to expand its wealth management business in India's WealthTech sector and continue expanding its presence in one of the country's fastest-growing financial services segments.",
    ],
  },
  {
    id: 5,
    tag: "TECH",
    status: "Draft",
    title:
      "Ola Electric's EV Registrations Jump 22% in May, TVS Retains Top Spot",
    subtitle:
      "Ola Electric posted a 22% increase in EV two-wheeler registrations in May, reflecting improving demand, while TVS Motor maintained its lead in India's competitive electric vehicle market.",
    time: "2 Jun",
    published: "2 June 2026",
    author: "Startup Unplugged",
    cover: "/news/5.jpg",
    pullQuote:
      '"While startups initially drove the electric scooter revolution, legacy manufacturers such as TVS, Bajaj, and Hero have leveraged their extensive dealer networks, manufacturing capabilities, and brand trust to gain significant market share."',
    body: [
      "India's electric two-wheeler market bounced back strongly in May 2026 after witnessing a slowdown in April, with registrations rising more than 8% month-on-month. Amid the broader market recovery, Ola Electric recorded a 22% increase in registrations, although TVS Motor continued to lead the segment.",
      "Ola Electric registered 15,139 electric two-wheelers in May, up from 12,323 units in April. The increase helped the Bhavish Aggarwal-led company improve its monthly performance after a challenging start to the year. However, Ola remained the fifth-largest player in the electric two-wheeler market with an 8.88% market share.",
      "TVS Motor retained its position as India's leading electric two-wheeler manufacturer in May, registering 42,376 units and capturing a 24.86% market share. Bajaj Auto followed closely with 39,104 registrations and a 22.94% share, continuing to narrow the gap with the market leader.",
      "Ather Energy secured the third spot with 28,190 registrations and a market share of 16.54%, while Hero MotoCorp's electric mobility business recorded 19,044 registrations, accounting for 11.17% of the market.",
      "The latest figures highlight the growing dominance of established automotive companies in India's EV ecosystem. While startups initially drove the electric scooter revolution, legacy manufacturers such as TVS, Bajaj, and Hero have leveraged their extensive dealer networks, manufacturing capabilities, and brand trust to gain significant market share.",
      "For Ola Electric, the growth in May registrations comes as the company focuses on improving customer experience, strengthening service infrastructure, and expanding its product portfolio. The company has faced increased competition over the past year as rivals introduced new electric scooter models and expanded their presence across the country.",
      "Industry experts believe India's electric two-wheeler market is entering a more competitive phase, where factors such as product reliability, after-sales service, financing options, and distribution reach will play a crucial role in determining market leadership.",
      "With EV adoption continuing to accelerate across urban and semi-urban markets, the competition among manufacturers is expected to intensify further in the coming months. While TVS currently leads the market, companies including Bajaj, Ather, Hero, and Ola Electric are all competing aggressively for a larger share of India's fast-growing electric mobility opportunity.",
      "The strong rebound in May registrations signals sustained consumer interest in electric two-wheelers, reinforcing expectations that the segment will remain one of the fastest-growing categories in India's automotive industry.",
    ],
  },
  {
    id: 6,
    tag: "DEEP DIVE",
    status: "Draft",
    title:
      "How Zepto, Blinkit and Instamart Are Helping D2C Brands Win the Summer Travel Boom",
    subtitle:
      "As India's summer travel season gathers pace, D2C brands are leveraging Zepto, Blinkit, and Swiggy Instamart to capture vacation-driven demand, turning the country's growing short-break economy into a new avenue for growth.",
    time: "2 Jun",
    published: "2 June 2026",
    author: "Startup Unplugged",
    cover: "/news/6.jpg",
    pullQuote:
      '"Consumers are no longer shopping only for destinations but also for the journey itself — from sunscreen and hydration products to healthy snacks and travel accessories."',
    body: [
      "India's growing summer travel season is emerging as a new consumption opportunity for direct-to-consumer (D2C) brands, with quick-commerce platforms such as Zepto, Blinkit, and Swiggy Instamart becoming key channels for capturing vacation-driven demand.",
      "Traditionally, D2C brands have relied heavily on festive seasons and year-end sales to drive growth. However, changing consumer behavior is creating a new seasonal demand cycle centered around short vacations, weekend getaways, family visits, and summer travel experiences.",
      "Recognising this shift, quick-commerce platforms have introduced dedicated categories and campaigns tailored to travel-related purchases. Platforms such as Blinkit, Zepto, and Instamart are highlighting vacation essentials, travel kits, snacks, personal care products, and family-focused bundles designed for consumers preparing for summer trips.",
      "For D2C brands, the trend presents an opportunity to reach customers at a moment when spending priorities are shifting toward convenience and travel readiness. Brands across categories including skincare, nutrition, packaged foods, beverages, wellness, and personal care are increasingly creating travel-sized products, curated bundles, and seasonal offerings to cater to vacationing consumers.",
      "Industry executives note that consumers are no longer shopping only for destinations but also for the journey itself. From sunscreen and hydration products to healthy snacks and travel accessories, shoppers are increasingly turning to quick-commerce platforms for last-minute purchases before vacations.",
      'The rise of India\'s "short-break economy" is also reshaping marketing strategies. Rather than focusing exclusively on traditional festive periods, brands are now designing campaigns around summer holidays, long weekends, and school vacations. This allows companies to engage consumers during multiple high-intent spending periods throughout the year.',
      "Quick-commerce platforms stand to benefit significantly from the trend. Their promise of delivering products within minutes aligns well with spontaneous travel planning and last-minute shopping needs. As a result, platforms are becoming important discovery channels for emerging D2C brands looking to increase visibility and drive impulse purchases.",
      "The trend highlights the broader evolution of India's consumer economy, where lifestyle-driven spending is creating new opportunities beyond conventional retail seasons. As domestic travel continues to grow and consumers increasingly prioritise experiences, brands are adapting their products, packaging, and marketing efforts to align with changing habits.",
      "For D2C startups, the summer travel season is no longer just a temporary demand spike. It is gradually emerging as a meaningful business opportunity capable of driving customer acquisition, boosting sales, and strengthening brand visibility in an increasingly competitive market.",
      "As India's travel economy expands, the intersection of quick commerce and D2C retail is expected to create new growth avenues, turning summer vacations into one of the most important seasonal opportunities for consumer brands.",
    ],
  },
  {
    id: 7,
    tag: "TECH",
    status: "Draft",
    title:
      "AutoTech Unicorn CARS24 Commits $20 Mn to Invest in Early-Stage AI Startups",
    subtitle:
      "Beyond Cars: AutoTech Unicorn CARS24 has launched CARS24 Labs with a $20 million commitment to invest in early-stage AI startups, support founders, and build AI-first products through strategic partnerships and ecosystem support.",
    time: "2 Jun",
    published: "2 June 2026",
    author: "Startup Unplugged",
    cover: "/news/7.jpg",
    pullQuote:
      '"We believe artificial intelligence represents the most significant technological shift of this generation." — Vikram Chopra, Founder & CEO, CARS24',
    body: [
      "Gurugram-based AutoTech unicorn CARS24 has announced a major artificial intelligence push with the launch of CARS24 Labs, a dedicated initiative aimed at building AI-first products, supporting founders and investing in early-stage AI startups. As part of the initiative, the company has committed $20 million (approximately ₹170-190 crore) to startups and teams developing transformative AI technologies.",
      "The move signals CARS24's ambition to expand beyond its core used-car marketplace business. The company said AI has already become deeply embedded across its operations, helping improve decision-making, product development, and customer experiences.",
      "According to the company, CARS24 Labs will operate across three core pillars — Build, Partner and Invest. Under the Build vertical, the company plans to create AI-native products and contribute to open-source innovation. The Partner arm will work with leading AI companies to accelerate experimentation and adoption, while the Invest division will provide capital and strategic support to startups building category-defining AI businesses.",
      "To strengthen the initiative, CARS24 has partnered with industry leaders including OpenAI, Amazon Web Services (AWS) and ElevenLabs. Through these partnerships, startups selected under the program will gain access to capital, infrastructure, mentorship, and access to leading AI technologies.",
      "Speaking about the initiative, CARS24 Founder and CEO Vikram Chopra said the company believes artificial intelligence represents the most significant technological shift of this generation. He added that the goal of CARS24 Labs is to back founders early, help them move faster, and support entrepreneurs building products that could define the future.",
      "Beyond direct investments, CARS24 Labs will also support the broader AI ecosystem through hackathons, builder programs, community initiatives, incubation efforts, and open-source projects aimed at accelerating innovation. The company recently hosted its AI-focused hackathon, Token'26, which attracted more than 1,000 applicants, highlighting growing interest in AI entrepreneurship across India.",
      "The announcement comes as Indian startups and enterprises increasingly race to integrate artificial intelligence into products and operations. With global AI adoption accelerating and investor interest in the sector remaining strong, CARS24 is positioning itself not just as an AI adopter but as a long-term enabler of the next generation of AI companies.",
      "The company is also preparing for a public listing and has been working to improve its financial performance. According to recent disclosures, CARS24 reported strong revenue growth while narrowing its EBITDA losses, as it continues to diversify its business and invest in future technologies.",
      "With CARS24 Labs, the SoftBank-backed startup is making its biggest AI bet yet, aiming to help build a new wave of AI-first startups while strengthening India's position in the global artificial intelligence ecosystem.",
    ],
  },
];

export const articlesAll = [
  {
    id: 1,
    tag: "FOUNDER STORY",

    title:
      "Ananya built her first product in a PG in Lajpat Nagar. It now does ₹80 Cr ARR.",
    excerpt:
      "No co-founder. No warm intros. No Ivy League degree. Just a 23-year-old with a broken laptop and a thesis about what India actually needs.",
    cover:
      "https://images.unsplash.com/photo-1771580425842-36380c98efc4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    author: "Simar Kohli",
    read: "14 min read",
  },
  {
    id: 2,
    tag: "OPINION",

    title:
      "Delhi's startup scene is louder than Bangalore's — and that's the whole point.",
    excerpt:
      "We spoke to 18 founders, 9 investors, and 4 WeWork receptionists. The verdict is unanimous and a little chaotic.",
    cover:
      "https://images.pexels.com/photos/24596462/pexels-photo-24596462.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1500",
    author: "Yashasvi Rao",
    read: "9 min read",
  },
  {
    id: 3,
    tag: "DEEP DIVE",

    title:
      "How a 4-person team out of Noida is quietly winning the AI agents war.",
    excerpt:
      "They don't have a deck. They don't have a website. They have one demo video, three customers, and a waitlist that grew 800% in November.",
    cover:
      "https://images.unsplash.com/photo-1641838005179-d93339564ba9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    author: "Kabir Sinha",
    read: "11 min read",
  },
  {
    id: 4,
    tag: "FOUNDER STORY",

    title: "He fired his co-founder, his entire team, and rebuilt in 90 days.",
    excerpt:
      "The most uncomfortable conversation we've had this year. He's still standing — and the company is profitable.",
    cover:
      "https://images.unsplash.com/photo-1642086893711-1591cbfa61fe?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    author: "Mehak Chawla",
    read: "16 min read",
  },
  {
    id: 5,
    tag: "OPINION",

    title: "Stop optimising for SEO. Start optimising for being remembered.",
    excerpt:
      "A working theory after 24 months of watching NCR founders ship the same five blog posts to Google.",
    cover:
      "https://images.unsplash.com/photo-1596129050968-24ea0d26f0ce?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    author: "Devansh Rao",
    read: "7 min read",
  },
  {
    id: 6,
    tag: "PROFILE",

    title: "The investor who only writes cheques over chai in Khan Market.",
    excerpt:
      "He has backed 14 unicorns. He has never once attended a pitch event. We sat with him for two hours.",
    cover:
      "https://images.pexels.com/photos/24596462/pexels-photo-24596462.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1500",
    author: "Aryan Sood",
    read: "12 min read",
  },
  {
    id: 7,
    tag: "DEEP DIVE",

    title: "Why every NCR founder is suddenly hiring from tier-3 cities.",
    excerpt:
      "Not because it's cheap. Because the work ethic, they say, is something they genuinely cannot find in Gurugram anymore.",
    cover:
      "https://images.unsplash.com/photo-1771580425842-36380c98efc4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    author: "Ira Kapoor",
    read: "13 min read",
  },
  {
    id: 8,
    tag: "FOUNDER STORY",

    title: "She raised her seed round inside a Domino's in Sector 18, Noida.",
    excerpt:
      "Two slices of farmhouse pizza, one term sheet, and a story that's now folklore inside the NCR seed scene.",
    cover:
      "https://images.unsplash.com/photo-1641838005179-d93339564ba9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    author: "Simar Kohli",
    read: "10 min read",
  },
];

export const featuredArticles = articlesAll.slice(0, 2);

export const founderBytes = [
  {
    id: 1,
    quote:
      "I didn't raise for 18 months. Best thing that ever happened to the company.",
    name: "Karan Mehra",
    role: "Founder, Loopday",
  },
  {
    id: 2,
    quote:
      "Delhi built us in a way Bangalore never could. The hustle is in the water here.",
    name: "Priya Taneja",
    role: "CEO, Monkhold",
  },
  {
    id: 3,
    quote:
      "The first 100 users will teach you more than 100 investors ever will.",
    name: "Arjun Bedi",
    role: "Co-founder, Pitstop.ai",
  },
  {
    id: 4,
    quote:
      "Every NCR founder I know started in a spare bedroom. That's not a flex — that's the stack.",
    name: "Tanvi Malhotra",
    role: "Founder, Sevenly",
  },
];

export const rftVideos = [
  {
    id: 1,
    title: "Raising ₹100 Cr without a pitch deck — with Vivaan Khosla",
    duration: "42:18",
    views: "184K",
    cover:
      "https://images.unsplash.com/photo-1641838005179-d93339564ba9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    video:
      "https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4",
    big: true,
  },
  {
    id: 2,
    title: "The Noida PG that produced 6 unicorn employees",
    duration: "18:04",
    views: "62K",
    cover:
      "https://images.unsplash.com/photo-1642086893711-1591cbfa61fe?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    video:
      "https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4",
  },
  {
    id: 3,
    title: "Firing your first 10 hires — a brutal conversation",
    duration: "27:51",
    views: "91K",
    cover:
      "https://images.unsplash.com/photo-1596129050968-24ea0d26f0ce?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    video:
      "https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4",
  },
];

export const events = [
  {
    id: 1,
    date: "14 DEC",
    title: "NCR Founders' Dinner // Vol. 07",
    location: "The Quorum, Gurugram",
    type: "Invite only",
    link: "https://lu.ma/startupunplugged-ncr-dinner-7",
  },
  {
    id: 2,
    date: "19 DEC",
    title: "Unplugged Live: Operators in AI",
    location: "91Springboard, Okhla",
    type: "Open RSVP",
    link: "https://lu.ma/startupunplugged-operators-ai",
  },
  {
    id: 3,
    date: "04 JAN",
    title: "The Cohort Mixer — Investors × Founders",
    location: "Claridges, Lutyens' Delhi",
    type: "Members only",
    link: "https://lu.ma/startupunplugged-cohort-mixer",
  },
  {
    id: 4,
    date: "22 JAN",
    title: "Real Founder Talks — Live Recording",
    location: "AIC, IIIT Delhi",
    type: "Free",
    link: "https://lu.ma/startupunplugged-rft-live",
  },
];

export const cohortStartups = [
  "Loopday",
  "Monkhold",
  "Pitstop.ai",
  "Sevenly",
  "Zerolith",
  "Harbr",
  "Tessera",
  "Northside",
  "Kairo",
  "Routed",
  "Ovent",
  "Paperly",
  "SignalCart",
  "Nimbly",
  "CredNest",
  "FlowLedger",
  "BharatGrid",
  "ScoutOS",
  "Rivet Labs",
  "Stacklane",
  "Kraftly",
  "UrbanMint",
  "PulseOps",
  "Cobalt AI",
  "MesaPay",
  "GrowPilot",
  "ByteHaat",
  "VaultDesk",
];

export const cohortInvestors = [
  {
    name: "Northbridge Capital",
    designation: "Seed fund",
    image: "https://i.pravatar.cc/320?img=12",
  },
  {
    name: "Deeptek Ventures",
    designation: "AI investor",
    image: "https://i.pravatar.cc/320?img=32",
  },
  {
    name: "Kapur Family Office",
    designation: "Family office",
    image: "https://i.pravatar.cc/320?img=47",
  },
  {
    name: "Mint Lane",
    designation: "Angel syndicate",
    image: "https://i.pravatar.cc/320?img=56",
  },
  {
    name: "Verge DLF",
    designation: "Early-stage VC",
    image: "https://i.pravatar.cc/320?img=68",
  },
  {
    name: "Atlas NCR",
    designation: "Operator fund",
    image: "https://i.pravatar.cc/320?img=15",
  },
];

export const cohortMentors = [
  {
    name: "Vikram Shetty",
    designation: "Fintech operator",
    image: "https://i.pravatar.cc/320?img=11",
  },
  {
    name: "Rhea Bajaj",
    designation: "Brand strategist",
    image: "https://i.pravatar.cc/320?img=20",
  },
  {
    name: "Aman Puri",
    designation: "B2B SaaS founder",
    image: "https://i.pravatar.cc/320?img=33",
  },
  {
    name: "Shreya Kapoor",
    designation: "Growth lead",
    image: "https://i.pravatar.cc/320?img=45",
  },
  {
    name: "Naveen Arora",
    designation: "Product mentor",
    image: "https://i.pravatar.cc/320?img=53",
  },
  {
    name: "Isha Gill",
    designation: "Community builder",
    image: "https://i.pravatar.cc/320?img=5",
  },
  {
    name: "Rohan Sethi",
    designation: "Marketplace operator",
    image: "https://i.pravatar.cc/320?img=60",
  },
  {
    name: "Deeksha Vyas",
    designation: "Fundraising coach",
    image: "https://i.pravatar.cc/320?img=25",
  },
];

export const teamMembers = [
  {
    id: 1,
    name: "Karan Talwar",
    role: "Founder",
    bio: "Building the loudest startup media brand in NCR.",
    photo:
      "https://media.licdn.com/dms/image/v2/D5603AQHbiD8TwSwMTA/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1711471802696?e=1779926400&v=beta&t=DXoxnQJX_VRWG_2rW-kzoELJw0ZOE5S_wPZIEBu57YI",
    group: "Founders",
    linkedin: "https://www.linkedin.com/in/karan-talwar-0660b1222/",
  },
  {
    id: 2,
    name: "Shounak Sengupta",
    role: "Operations",
    bio: "Story-first. Founder-obsessed. Always shipping.",
    photo:
      "https://media.licdn.com/dms/image/v2/D5603AQEdrZAx4F8JUQ/profile-displayphoto-crop_800_800/B56ZtmKhssJgAI-/0/1766945594754?e=1779926400&v=beta&t=FQ_BHmQjj4TkGLLUN5fwHaa7WKWQWWNVb1HE0uFWy8A",
    group: "Operations",
    linkedin: "https://www.linkedin.com/in/shounak-sengupta-232097122/",
  },
  {
    id: 3,
    name: "Sunil Shimalwal",
    role: "Operations & Growth",
    bio: "Runs the engine room. Cohorts, events, partnerships.",
    photo:
      "https://media.licdn.com/dms/image/v2/D5603AQGuP9FxhtkvFw/profile-displayphoto-shrink_800_800/B56ZiT.kx6G4Ag-/0/1754829323283?e=1779926400&v=beta&t=frv4U_QevcXEMT7SkTUVWUgZzrSGStWvd9bBon5C-5E",
    group: "Core Team",
    linkedin: "https://www.linkedin.com/in/sunilshimalwal/",
  },
  {
    id: 4,
    name: "Shweta Singla",
    role: "Editorial Lead",
    bio: "Where our stories get sharper before they ship.",
    photo:
      "https://media.licdn.com/dms/image/v2/D4D03AQEoZZyQFu8fsA/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1689780657669?e=1779926400&v=beta&t=9r3Dbv6PxnSdvbR1k0HwqLq-k6wYifktK61acOIeQN4",
    group: "Core Team",
    linkedin: "https://www.linkedin.com/in/shweta-singla-570540113/",
  },
  {
    id: 5,
    name: "Nikita Verma",
    role: "Head of Stories",
    bio: "Writes the bits other publications are too polite to print.",
    photo:
      "https://images.unsplash.com/photo-1771580425842-36380c98efc4?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    group: "Core Team",
  },
  {
    id: 6,
    name: "Rehan Qureshi",
    role: "Producer, RFT",
    bio: "Knows every founder in NCR on a first-name basis.",
    photo:
      "https://images.unsplash.com/photo-1596129050968-24ea0d26f0ce?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    group: "Core Team",
  },
  {
    id: 7,
    name: "Mehak Chawla",
    role: "Contributor",
    bio: "Ex-founder. Writes biweekly about what she broke.",
    photo:
      "https://images.unsplash.com/photo-1771580425842-36380c98efc4?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    group: "Contributors",
  },
  {
    id: 8,
    name: "Aryan Sood",
    role: "Contributor",
    bio: "Deals desk. Sees your cap table before you do.",
    photo:
      "https://images.unsplash.com/photo-1596129050968-24ea0d26f0ce?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    group: "Contributors",
  },
];

export const socialLinks = [
  { label: "Instagram", href: "#" },
  { label: "Twitter / X", href: "#" },
  { label: "LinkedIn", href: "#" },
  { label: "YouTube", href: "#" },
  { label: "Spotify", href: "#" },
];
